import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  headerWrapper: {
    marginBottom: theme.spacing(2),
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  titleSkeleton: {
    flex: 1,
    maxWidth: '60%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  editIconSkeleton: {
    flexShrink: 0,
  },
  dateSkeleton: {
    marginTop: theme.spacing(0.5),
    maxWidth: '40%',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  setGroupSkeleton: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: '10px',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  setGroupTitle: {
    marginBottom: theme.spacing(1.5),
  },
  setRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    marginTop: theme.spacing(1),
    borderRadius: '10px',
  },
  addBlockSkeleton: {
    marginTop: theme.spacing(2),
    borderRadius: '10px',
  },
  buttonSkeleton: {
    marginTop: theme.spacing(2),
    borderRadius: '10px',
  },
}));
